<template>
 <section>
   <b-card class="visitor-bans">
     <b-card-title class="d-flex justify-content-between align-items-center">
       Visitors Bans

       <b-btn v-if="editable" variant="success" @click="openAddBan()">
         <span class="fa fa-sm fa-plus"></span> Add Video Call Ban
       </b-btn>
     </b-card-title>

     <section v-if="loading">
       <b-spinner variant="primary" label="Loading bans"></b-spinner>
     </section>

     <section v-else>
       <div class="bans-table" v-if="bans && bans.length > 0">
         <p><b>Previous and Active Bans</b></p>
         <b-table
           hover
           :fields="columns"
           :items="bans"
           :current-page="currentPage"
           :per-page="perPage"
           :responsive="true"
         >
           <template #cell(actions)="data">
             <span
               class="fa fa-sm fa-trash hover hover-danger"
               @click="removeBan(data.item._id)"
             ></span>
           </template>
         </b-table>
       </div>
       <b-row v-if="bans && bans.length > 0">
         <b-col md="6" class="my-1">
           <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
         </b-col>
       </b-row>
       <div v-if="!bans || bans.length === 0">
         <p class="mb-0">Visitor has never been banned</p>
       </div>
     </section>
   </b-card>

   <b-modal id="modal-video-ban" hide-footer>
     <add-ban :visitor_user_id="visitor_user_id" @close="closeAndRefresh()"></add-ban>
   </b-modal>
 </section>
</template>

<script>
  import VisitorService from '@/services/VisitorService';
  import AddBan from './AddBan';
  import moment from 'moment';
  import {ERROR_CODES} from '@/util/errorCodes';

  const COLUMNS_NO_EDIT = [
    {
      key: 'reasonFormatted',
      label: 'Reason',
    },
    {
      key: 'start',
      label: 'Start',
    },
    {
      key: 'end',
      label: 'End',
    },
  ];

  const COLUMNS_EDIT = [
    {
      key: 'reasonFormatted',
      label: 'Reason',
    },
    {
      key: 'start',
      label: 'Start',
    },
    {
      key: 'end',
      label: 'End',
    },
    {
      key: 'actions',
      label: 'Actions',
    },
  ];

  export default {
    name: 'visitor-bans',
    components: {
      AddBan,
    },
    props: {
      visitor_user_id: {
        type: String,
        required: true,
      },
      editable: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    watch: {
      visitor_user_id() {
        // Get new visitor info
        this.getVisitorsBans();
      },
    },
    data() {
      return {
        loading: true,
        bans: [],
        columns: this.editable ? COLUMNS_EDIT : COLUMNS_NO_EDIT,
        currentPage: 1,
        perPage: 5,
        totalRows: 0,
      };
    },
    mounted() {
      this.getVisitorsBans();
    },
    methods: {
      closeAndRefresh() {
        this.$bvModal.hide('modal-video-ban');
        this.getVisitorsBans();
      },
      getVisitorsBans() {
        VisitorService.getVisitorBans(this.visitor_user_id).then(res => {
          this.bans = res.data.sort((b1, b2) => {
            const b1StartDate = new Date(b1.start_date);
            const b2StartDate = new Date(b2.start_date);
            return b2StartDate.getTime() - b1StartDate.getTime();
          }).map((ban) => {
            return {
              reasonFormatted: ban.reason ? ban.reason : '-',
              start: moment(ban.start_date).format('DD/MM/YYYY'),
              end: moment(ban.end_date).format('DD/MM/YYYY'),
              ...ban,
            };
          });
          this.totalRows = this.bans.length;
          this.loading = false;
        }).catch(err => {
         this.$toast.error('Error getting users bans', {
           toastClassName: ['toast-std', 'warning-toast'],
         });
        });
      },
      openAddBan() {
        this.$bvModal.show('modal-video-ban');
      },
      removeBan(banId) {
        this.$swal({
          title: 'Are you sure?',
          text: 'Once removed you wont be able to recover the ban',
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        }).then((willDelete) => {
          if(willDelete) {
            // Remove the ban
            VisitorService.removeVisitorBan(banId).then(res => {
              // Filter the ban from the list
              this.bans = this.bans.filter((ban) => {
                return ban._id !== banId;
              });
              // Set total rows
              this.totalRows = this.bans.length;
              // Show success
              this.$swal('ban successfully removed!', {
                icon: 'success',
              });
            }).catch(err => {
              let msg = 'Error removing the ban. Please refresh the page and try again';
              if(err && err.response && err.response.data && err.response.data === ERROR_CODES.ENTITY.NOT_FOUND) {
                msg = 'Error removing the ban as it no longer exists';
              }

              this.$toast.error(msg, {
                toastClassName: ['toast-std', 'warning-toast'],
              });
            });
          }
        });
      },
    },
  };
</script>

